<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'Card',

    emits: ['click'],
  })
</script>

<template>
  <div class="card" @click="$emit('click', $event)">
    <header v-if="$slots.header">
      <slot name="header" />
    </header>

    <div class="body">
      <slot />
    </div>

    <footer v-if="$slots.footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style lang="sass" scoped>
  @use "sass:math"
  @use '@/variables' as *

  .card
    width: 100%
    background-color: $surface
    border: 1px solid $border-color
    border-radius: $default-border-radius
    padding: $default-space
    margin-bottom: $default-space
    overflow: hidden
    box-shadow: $shadow-sm

    h2
      line-height: 1.25rem

    h2 + .table-container
      margin-top: -1.5rem

    header
      padding-bottom: math.div($default-space, 2)

    header,
    .body,
    footer
      *:first-child
        margin-top: 0

      *:last-child
        margin-bottom: 0

    h4
      margin-bottom: .25rem

    p
      margin-top: 0

    footer
      padding-top: math.div($default-space, 2)

    form
      margin-bottom: .5rem

      .form-group
        margin-bottom: 1rem

        &:last-of-type
          margin-bottom: 0

      label
        display: inline-block
        width: 100%
        margin-bottom: .25rem
        font-weight: bold
</style>
